module.exports = __webpack_public_path__ + "img/3987026_s.2f791d3e.jpg";